/**
 * <h1>Listar Component</h1>
 *<p>
 * El componente listar se encarga obtener una lista de elementos
 * de la api con los parametros y filtros que se especifiquen,
 * interactua con el servicio crud
 * </p>
 *
 * @author  Eliecer Ramirez Esquinca
 * @version 1.0
 * @since   2017-05-08
 */

import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Router } from "@angular/router";

import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, catchError, map} from 'rxjs/operators';

import { AuthService } from "../auth.service";
import { CrudService } from "./crud.service";
import { environment } from "../../environments/environment";

import { Mensaje } from "../mensaje";
import { NotificationsService,SimpleNotificationsComponent} from 'angular2-notifications';

import { CurrencyPipe } from "@angular/common";
import { NumeroLetraPipe } from '../pipes/numero-letra.pipe';

import jsPDF from 'jspdf'; import autoTable from 'jspdf-autotable'; import * as jQuery from 'jquery';
import { isArray } from "util";
import { saveAs } from "file-saver";

@Component({
  selector: "app-listar",
  template: `<a id="logo64" (click)="asignarLogos(logos64); "></a>
  <simple-notifications [options]="options"></simple-notifications>
    <div class="modal" id="confirmarEliminar">
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
            <p class="modal-card-title"><i class="fa fa-warning"></i> Alerta</p>
            <button class="delete" (click)="cancelarModal()"></button>
            </header>
            <section class="modal-card-body">
                <div class="content">
                    <h1>¿Esta seguro de eliminar el elemento????</h1>
                    <p>Ya no se podra recuperar la información</p>
                </div>
            </section>
            <footer class="modal-card-foot">
            <a class="button is-success" (click)="borrar(borrarItem, borrarIndex)" [ngClass]="{'is-loading': borrarCargando}">Continuar</a>
            <a class="button" (click)="cancelarModal()">Cancelar</a>
            </footer>
        </div>
    </div>`
})
export class ListarComponent implements OnInit {
  cargando: boolean = false;
  borrarCargando: boolean = false;
  // # SECCION: Esta sección es para mostrar mensajes

  ultimaPeticion: any;
  tamano = document.body.clientHeight;

  //dato es el modelo general que contiene los datos del formulario
  dato: any[] = [];
  respuesta: any[] = [];
  mensajeResponse: Mensaje = new Mensaje(true);

  paginaActual = 1;
  resultadosPorPagina = 15;
  total = 0;
  paginasTotales = 0;
  indicePaginas: number[] = [];

  conf_paginacion = {
    paginaActual: 1,
    resultadosPorPagina: 25,
    total: 0,
    paginasTotales: 0,
    indicePaginas: []
  };
  // # FIN SECCION

  // # SECCION: Resultados de búsqueda
  conf_paginacion_busqueda = {
    ultimoTerminoBuscado: '',
    resultadosBusqueda: [],
    busquedaActivada: false,
    paginaActualBusqueda: 1,
    resultadosPorPaginaBusqueda: 15,
    totalBusqueda: 0,
    paginasTotalesBusqueda: 0,
    indicePaginasBusqueda: []
  };

  parametros = {
    pagina: 1,
    limite:25,
    columna: null,
    valor:null,
    buscar:true,
    order:'id'
  };
  // # FIN SECCION

  // # SECCION: Resultados de búsqueda
  ultimoTerminoBuscado = "";
  terminosBusqueda = new Subject<string>();
  resultadosBusqueda: any[] = [];
  busquedaActivada: boolean = false;
  paginaActualBusqueda = 1;
  resultadosPorPaginaBusqueda = 15;
  totalBusqueda = 0;
  paginasTotalesBusqueda = 0;
  indicePaginasBusqueda: number[] = [];
  tipo_grid;
  // # FIN SECCION
  API_PATH = environment.API_PATH;

  permisos = JSON.parse(localStorage.getItem("permisos"));
  configuracion = JSON.parse(localStorage.getItem("configuracion"));

  @Input() URL: string;
  @Input() titulo: string;

  /**
   * Este método inicializa la carga de las dependencias
   * que se necesitan para el funcionamiento del modulo
   */
  constructor(
    private title: Title,
    private crudService: CrudService,
    private authService: AuthService,
    private notificacion: NotificationsService
  ) {}

  /**
   * Este método se dispara al iniciar la carga de la vista asociada
   * en este caso se utiliza para cargar la lista inicial
   * @return void
   */
  ngOnInit() {
    if(!document.getElementById("nohacer")) {
      this.listar(1);
    }

    this.title.setTitle(this.titulo);
    let self = this;
    this.tipo_grid =
      localStorage.getItem("tipo_grid") == "false" ? false : true;

    let busquedaSubject = this.terminosBusqueda
    .pipe(debounceTime(300)) // Esperamos 300 ms pausando eventos
      .pipe(distinctUntilChanged()) // Ignorar si la busqueda es la misma que la ultima
      .pipe(switchMap((term: string) => {
        this.busquedaActivada = term != "" ? true : false;

        this.ultimoTerminoBuscado = term;
        this.paginaActualBusqueda = 1;
        this.cargando = true;
        return term
          ? this.crudService.buscar(
              term,
              this.paginaActualBusqueda,
              this.resultadosPorPaginaBusqueda,
              this.URL
            )
          : Observable.call({ data: [], total: 0 });
      }),catchError(function handleError(error) {
        self.cargando = false;
        self.mensajeResponse.mostrar = true;
        self.ultimaPeticion = function() {
          self.listarBusqueda(
            self.ultimoTerminoBuscado,
            self.paginaActualBusqueda
          );
        }; //OJO
        try {
          let e = error.json();
          if (error.status == 401) {
            self.mensajeResponse.texto =
              "No tiene permiso para hacer esta operación.";
            self.mensajeResponse.clase = "danger";
            this.mensaje(2);
          }
        } catch (e) {
          if (error.status == 500) {
            self.mensajeResponse.texto = "500 (Error interno del servidor)";
          } else {
            self.mensajeResponse.texto =
              "No se puede interpretar el error. Por favor contacte con soporte técnico si esto vuelve a ocurrir. 6";
          }
          self.mensajeResponse.clase = "danger";
          this.mensaje(2);
        }
        // Devolvemos el subject porque si no se detiene el funcionamiento del stream
        return busquedaSubject;

      }));

    busquedaSubject.subscribe(resultado => {
      this.cargando = false;
      this.resultadosBusqueda = this.dato;
      this.dato = resultado.data as any[];
      this.total = 0;
      this.totalBusqueda = resultado.total | 0;
      this.paginasTotalesBusqueda = Math.ceil(
        this.totalBusqueda / this.resultadosPorPaginaBusqueda
      );

      this.indicePaginasBusqueda = [];
      for (let i = 0; i < this.paginasTotalesBusqueda; i++) {
        this.indicePaginasBusqueda.push(i + 1);
      }
    });

    this.obtenerCatalogos('logos64', 'logos64', 'logo64');
  }
  cambiar_filas_pagina(totalPorPagina: HTMLInputElement) {
    if (this.busquedaActivada) {
      this.resultadosPorPaginaBusqueda = parseInt(totalPorPagina.value);
      let term = <HTMLInputElement>document.getElementById("search-box");
      this.listarBusqueda(term.value, this.paginaActual);
    } else {
      this.resultadosPorPagina = parseInt(totalPorPagina.value);
      this.listar(this.paginaActual);
    }
  }

  cambiar_vista = function() {
    this.tipo_grid = !this.tipo_grid;
    localStorage.setItem("tipo_grid", this.tipo_grid);
    this.listar(this.paginaActual);
  };

  /**
   * Este método es un intermediario para realizar la busqueda en
   * api con los filtros que se especifiquen en la vista
   * @param term contiene las palabras de busqueda
   * @return void
   */
  buscar(term: string): void {
    this.terminosBusqueda.next(term);
  }

  cerrar_busqueda(buscar: HTMLInputElement) {
    this.busquedaActivada = false;
    buscar.value = null;
    this.dato = this.resultadosBusqueda;
    this.resultadosBusqueda = [];
    if (this.dato.length <= 0) this.listar(this.paginaActual);
  }
  /**
   * Este método obtiene una lista de elementos de la
   * api con los filtros que se especifiquen en la vista
   * @param term contiene las palabras de busqueda
   * @param pagina  inicio de la página para mostrar resultados
   * @return void
   */
  listarBusqueda(term: string, pagina: number): void {
    this.paginaActualBusqueda = pagina;
    this.total = 0;
    this.cargando = true;
    this.crudService
      .buscar(term, pagina, this.resultadosPorPaginaBusqueda, this.URL)
      .subscribe(
        resultado => {
          this.cargando = false;

          this.resultadosBusqueda = this.dato;
          this.dato = resultado.data as any[];

          this.totalBusqueda = resultado.total | 0;
          this.paginasTotalesBusqueda = Math.ceil(
            this.totalBusqueda / this.resultadosPorPaginaBusqueda
          );

          this.indicePaginasBusqueda = [];
          for (let i = 0; i < this.paginasTotalesBusqueda; i++) {
            this.indicePaginasBusqueda.push(i + 1);
          }
          this.tamano = document.body.clientHeight;
        },
        error => {
          this.cargando = false;
          this.mensajeResponse.mostrar = true;
          this.ultimaPeticion = function() {
            this.listarBusqueda(term, pagina);
          };
          try {
            let e = error.json();
            if (error.status == 401) {
              this.mensajeResponse.texto =
                "No tiene permiso para hacer esta operación.";
              this.mensajeResponse.clase = "danger";
              this.mensaje(2);
            }
          } catch (e) {
            if (error.status == 500) {
              this.mensajeResponse.texto = "500 (Error interno del servidor)";
            } else {
              this.mensajeResponse.texto =
                "pretar el error. Por favor contacte con soporte técnico si esto vuelve a ocurrir. 7";
            }
            this.mensajeResponse.clase = "danger";
            this.mensaje(2);
          }
        }
      );
  }
  actualizarUrl(url) {
    this.URL = url;
    this.listar(1);
  }
  /**
   * Este método obtiene una lista de elementos de la api
   * @param pagina  inicio de la página para mostrar resultados
   * @return void
   */
  listar(pagina: number): void {
    this.conf_paginacion.paginaActual = pagina;
    this.conf_paginacion_busqueda.totalBusqueda = 0;
    this.cargando = true;

    this.parametros.pagina = pagina;
    this.parametros.limite = this.conf_paginacion.resultadosPorPagina;

    const term = document.getElementById('search-box') as HTMLInputElement;

    if(term.value != null && term.value != ''){
      this.parametros.columna = null;
      this.parametros.valor = term.value;
      this.parametros.buscar = false;
    }else{
      delete this.parametros.columna;
      delete this.parametros.valor;
      delete this.parametros.buscar;
    }
    this.parametros.order = 'id';
    
    
    this.crudService.lista(this.parametros, this.URL).subscribe(
        resultado => {
          this.cargando = false;
          this.dato = resultado.data as any[];

          this.total = resultado.total | 0;
          this.paginasTotales = Math.ceil(
            this.total / this.resultadosPorPagina
          );

          this.indicePaginas = [];
          for (let i = 0; i < this.paginasTotales; i++) {
            this.indicePaginas.push(i + 1);
          }
          this.tamano = document.body.clientHeight;

          this.mensajeResponse.mostrar = true;
          this.mensajeResponse.texto = "lista cargada";
          this.mensajeResponse.clase = "success";
          this.mensaje(2);
        },
        error => {
          this.cargando = false;
          this.mensajeResponse.mostrar = true;
          this.ultimaPeticion = this.listar;
          try {
            
            let e = error.json();
            if (error.status == 401) {
              this.mensajeResponse.texto =
                "No tiene permiso para hacer esta operación.";
              this.mensajeResponse.clase = "danger";
              this.mensaje(2);
            }
          } catch (e) {
            if (error.status == 500) {
              this.mensajeResponse.texto = "500 (Error interno del servidor)";
            } else {
              this.mensajeResponse.texto =
                "No se puede interpretar el error. Por favor contacte con soporte técnico si esto vuelve a ocurrir. 8";
            }
            
            this.mensajeResponse.clase = "danger";
            this.mensaje(2);
          }
        }
      );
  }
  //abre una modal para confirmar la eliminacion
  borrarItem = "";
  borrarIndex = "";

  /**
   * Este método es intermediario para la eliminación de un elemento
   * en la api, abre una ventana modal para confirmar la acción
   * @param item contiene el valod del elemento a eliminar
   * @param index  indica la posicion del elemento en la lista cargada
   * @return void
   */
  eliminar(item: any, index): void {
    this.borrarItem = item;
    this.borrarIndex = index;
    document.getElementById("confirmarEliminar").classList.add("is-active");
  }

  /**
   * Este método cierra el modal de la de confirmación de eleimnación
   * @return void
   */
  cancelarModal(id = "confirmarEliminar") {
    document.getElementById(id).classList.remove("is-active");
  }

  /**
   * Este método se encarga de la eliminacion de un elemento
   * en la api
   * @param item contiene el valod del elemento a eliminar
   * @param index  indica la posicion del elemento en la lista cargada
   * @return void
   */
  borrar(item: any, index): void {
    item.cargando = true;
    this.borrarCargando = true;
    this.crudService.eliminar(item.id, this.URL).subscribe(
      data => {
        item.cargando = false;
        this.borrarCargando = false;

        this.dato.splice(index, 1);

        this.mensajeResponse.mostrar = true;
        this.mensajeResponse.texto = "Se eliminó el elemento de la lista.";
        this.mensajeResponse.clase = "success";
        this.mensaje(2);

        this.cancelarModal();
      },
      error => {
        item.cargando = false;
        this.borrarCargando = false;

        this.mensajeResponse.mostrar = true;
        this.ultimaPeticion = function() {
          this.eliminar(item, index);
        };
        this.cancelarModal();

        try {
          let e = error.json();
          if (error.status == 401) {
            this.mensajeResponse.texto =
              "No tiene permiso para hacer esta operación.";
            this.mensajeResponse.clase = "danger";
            this.mensaje(2);
          }
        } catch (e) {
          if (error.status == 500) {
            this.mensajeResponse.texto = "500 (Error interno del servidor)";
          } else {
            this.mensajeResponse.texto =
              "No se puede interpretar el error. Por favor contacte con soporte técnico si esto vuelve a ocurrir. 9";
          }
          this.mensajeResponse.clase = "danger";
          this.mensaje(2);
        }
      }
    );
  }

  // # SECCION: Paginación

  /**
   * Este método es intermediario para el listado incrementa en uno la paginación
   * @return void
   */
  paginaSiguiente(): void {
    console.log(this.paginaActual);
    if (this.busquedaActivada) {
      let term = <HTMLInputElement>document.getElementById("search-box");
      this.listarBusqueda(term.value, this.paginaActualBusqueda += 1);
    } else {
      this.listar(this.paginaActual += 1);
    }
  }

  /**
   * Este método es intermediario para el listado decrementa en uno la paginación
   * @return void
   */
  paginaAnterior(): void {
    if (this.busquedaActivada) {
      let term = <HTMLInputElement>document.getElementById("search-box");
      this.listarBusqueda(term.value, this.paginaActualBusqueda -= 1);
    } else {
      this.listar(this.paginaActual -= 1);
    }
  }

  /**
   * Este método es intermediario para el listado
   * @return void
   */
  mostrarLista(pagina: number): void {
    if (this.busquedaActivada) {
      let term = <HTMLInputElement>document.getElementById("search-box");
      this.listarBusqueda(term.value, pagina);
    } else {
      this.listar(pagina);
    }
  }
  cargarDatosCatalogo: boolean = false;
  intento1 = 0;
 
  cargarCatalogo(item, url, id: string = "", cargando = "") {
    this.cargando = true;
    this[cargando] = true;
    this[item] = [];

    this.parametros.pagina = 0;
    this.parametros.limite = 0;
    
    this.crudService.lista(this.parametros, url).subscribe(
      resultado => {
        if (Array.isArray(resultado.data)) {
          resultado.data.forEach(element => {
            if (!element.text) {
              element.text = element.nombre;
            }
          });
        }
        this[item] = resultado.data;
        this.cargando = false;
        if (resultado.length == 0) {
          this.mensajeResponse.titulo = item;
          this.mensajeResponse.texto = `Esta vacio, póngase en contacto con un administrador.`;
          this.mensajeResponse.mostrar = true;
          this.mensajeResponse.clase = "warning";
          this.mensaje(3);
        }
        this[cargando] = false;
        if (id != "") {
          setTimeout(() => {
            if(document.getElementById(id))
            document.getElementById(id).click();
          }, 300);
        }
        this.intento1 = 0;
      },
      error => {
        this[cargando] = false;
        this.mensajeResponse = new Mensaje(true);
        this.mensajeResponse.texto = "No especificado.";
        this.mensajeResponse.mostrar = true;

        try {
          let e = error.json();

          if (error.status == 401) {
            this.mensajeResponse.texto = "No tiene permiso para ver los roles.";
          } else {
            setTimeout(() => {
              if (this.intento1 < 1) {
                this.cargarCatalogo(item, url, id);
                this.intento1++;
              }
            }, 200);
          }
        } catch (e) {
          setTimeout(() => {
            if (this.intento1 < 1) {
              this.cargarCatalogo(item, url, id);
              this.intento1++;
            }
          }, 200);
        }
      }
    );
  }
  /**
   * Este metodo se encarga de cargar los datos de un catalogo que depende de otro
   * @param url  ruta de la pai donde se obtienen los valores
   * @param item nombre del modelo donde se guardaron los resultados
   * @param id  id del catalogo del que depende
   * @return void
   */
  catalogoDependiente = function(url, item, id) {
    this.cargarDatosCatalogo = true;
    this.crudService.lista(this.parametros, url + "?id=" + id).subscribe(
      resultado => {
        resultado.data.forEach(element => {
          if (!element.text) element.text = element.nombre;
        });
        this[item] = resultado.data;
        if (resultado.length == 0) {
          this.mensajeResponse.titulo = item;
          this.mensajeResponse.texto = `Esta vacio, póngase en contacto con un administrador.`;
          this.mensajeResponse.mostrar = true;
          this.mensajeResponse.clase = "warning";
          this.mensaje(3);
        }
        this.cargarDatosCatalogo = false;
      },
      error => {
        this.mensajeResponse = new Mensaje(true);
        this.mensajeResponse.texto = "No especificado.";
        this.mensajeResponse.mostrar = true;

        try {
          let e = error.json();

          if (error.status == 401) {
            this.mensajeResponse.texto = "No tiene permiso para ver los roles.";
          }

          if (error.status == 500) {
            this.mensajeResponse.texto =
              "500 (Error interno del servidor). No se pudieron cargar los roles";
          }
        } catch (e) {
          if (error.status == 500) {
            this.mensajeResponse.texto =
              "500 (Error interno del servidor). No se pudieron cargar los roles";
          } else {
            this.mensajeResponse.texto =
              "No se puede interpretar el error. Por favor contacte con soporte técnico si esto vuelve a ocurrir.  No se pudieron cargar los roles";
          }
        }
        this.cargarDatosCatalogo = false;
      }
    );
  };
  //mostrar notificaciones
  public options = {
    position: ["bottom", "left"],
    timeOut: 2000,
    lastOnBottom: true
  };

  /**
   * Este método muestra los mensajes resultantes de los llamados de la api
   * @param cuentaAtras numero de segundo a esperar para que el mensaje desaparezca solo
   * @param posicion  array de posicion [vertical, horizontal]
   * @return void
   */
  mensaje(cuentaAtras: number = 6, posicion: any[] = ["bottom", "left"]): void {
    let objeto = {
      showProgressBar: true,
      pauseOnHover: true,
      clickToClose: true,
      maxLength: this.mensajeResponse.texto.length
    };

    this.options = {
      position: posicion,
      timeOut: cuentaAtras * 1000,
      lastOnBottom: true
    };
    if (this.mensajeResponse.titulo == "")
      this.mensajeResponse.titulo = this.titulo;

    if (this.mensajeResponse.clase == "alert")
      this.notificacion.alert(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (this.mensajeResponse.clase == "success")
      this.notificacion.success(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (this.mensajeResponse.clase == "info")
      this.notificacion.info(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (
      this.mensajeResponse.clase == "warning" ||
      this.mensajeResponse.clase == "warn"
    )
      this.notificacion.warn(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (
      this.mensajeResponse.clase == "error" ||
      this.mensajeResponse.clase == "danger"
    )
      this.notificacion.error(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );
  }

/**
 * Este método muestra los mensajes resultantes de los llamados de la api
 * @param titulo Titulo del mensaje
 * @param texto  Texto a mostrar en el mensaje
 * @param mostrar  Bandera para mostrar el mensaje defalut true
 * @param clase  Color del mensaje ( success, warning, danger, info, alert)
 * @param tiempo  Tiempo en segundos para desaparecer el mensaje
 * @return void
 */
  mensaje_mostrar(titulo, texto, mostrar = true, clase = "warning", tiempo = 3) {
    this.mensajeResponse.titulo = titulo;
    this.mensajeResponse.texto = texto;
    this.mensajeResponse.mostrar = mostrar;
    this.mensajeResponse.clase = clase;
    this.mensaje(tiempo);
  }

  mostrar_mensaje(titulo, mensaje, clase) {
    this.mensajeResponse.titulo = titulo;
    this.mensajeResponse.texto = mensaje;
    this.mensajeResponse.mostrar = true;
    this.mensajeResponse.clase = clase;
    this.mensaje(3);
  }

  json;
  imprimir_cargando = false;
  contador;

  imprimir(json, contador, titulo = "") {
    this.contador = contador;
    if (document.getElementById("imprimir_local"))
      document.getElementById("imprimir_local").click();
    else {
      this.json = json;

      if (document.getElementById("funcion_secundaria" + contador)) {
        document.getElementById("funcion_secundaria" + contador).click();
      } else{

        this.imprimir_cargando = true;

        $("#exportar_datos").find("table").attr("id", "tabla");

        let doc = new jsPDF("p", "mm", "letter");

        let logo = this.logo_sucursal != '' ? this.logo_sucursal : this.logo_empresa;
        if (logo != '' && logo != undefined && logo != null)
          doc.addImage(logo, "PNG", 10, 5, 25, 20, "left", "FAST");

        let linea = 12;
        //Header
        doc.setFontSize(16);
        doc.setFont("courier");
        doc.setFont("courier", "", "bold");
        doc.text(this.configuracion.empresa.nombre,115, linea,  {align:"center"});
        linea += 4;
        doc.setFontSize(10);
        doc.setFont("courier", "", "bold");
        doc.text(this.configuracion.sucursal.direccion.split(",")[0],115, linea,  {align:"center"});
        linea += 4;
        doc.text(this.configuracion.sucursal.direccion.split(",")[1],115, linea,  {align:"center"});
        linea += 4;
        doc.text("RFC: " + this.configuracion.sucursal.facturacion.rfc,115, linea,  {align:"center"});
        linea += 6;

        doc.setFont("courier", "", "bold");
        doc.setFontSize(6);
        doc.text('---------------------------------------------------------------------------------------------------------------------------------------------------------------',110, linea,  {align:'center'});
        linea += 6;

        doc.setFontSize(12);
        doc.text( titulo,115, linea,{align: 'center'});
        linea += 6;

        let elem = document.getElementById("tabla") ? document.getElementById("tabla") : '';
        let data = (doc as any).autoTableHtmlToJson(elem);

        (doc as any).autoTable(data.columns, data.rows, {
          didParseCell : function (cell) {
              let data= cell;
              cell = cell.cell;
            cell.styles.fillColor = "#ffffff";
          },
          startY: linea,
          styles: {
            fontSize: 5, font: "helvetica",
            halign: "center",
            fillColor: "#FFFFFF",
            textColor: "#000000",
            lineColor: "#000000",
            lineWidth: 0.3
          },
          headStyles: {
            lineColor: "#000000",
            lineWidth: 0.3
          },
          tableWidth: 'auto',
          margin: { right: 5, left: 10 },
        });


        // doc.autoPrint();
        //const string = (doc as any).output('datauristring', titulo + '.pdf');
        window.open((doc as any).output('bloburl'), '_blank');
        /*const iframe = "<iframe border='0' style='border:0px' width='100%' height='100%' src='" + string + "'></iframe>"

        const x = window.open();
        x.document.open();
        x.document.write(iframe);
        x.document.close();*/
      }
    }
  }

  imprimeTicket(item) {
    let paginaAlto = 350;
    if (!item.hasOwnProperty("movimientos")) {
      item.movimientos = item;
    }

    paginaAlto = paginaAlto + (item.movimientos.movimientos_articulos.length * 20);

    let doc = new jsPDF("p", "mm", [200, paginaAlto]);
    let imgData = 'data:image/jpeg;base64,' + item.movimientos.barcode;
    //Header
    doc.setFontSize(9);
    doc.setFont("courier");
    doc.setFont("courier", "", "bold");
    doc.text( this.configuracion.empresa.nombre,35, 6, {align:"center"});

    doc.setFontSize(8);
    doc.setFont("courier", "", "bold");
    doc.text(this.configuracion.sucursal.direccion.split(",")[0], 35, 10, {align:"center"});
    doc.text(this.configuracion.sucursal.direccion.split(",")[1],35, 13,  {align:"center"});
    doc.text("RFC: " + this.configuracion.sucursal.facturacion.rfc,35, 18,  {align:"center"});

    doc.setFont("courier", "", "bold");
    doc.setFontSize(6);
    doc.text('--------------------------------------------------', 35, 23, {align:'center'});

    doc.setFontSize(7);
    doc.text('Campus: ' + this.configuracion.sucursal.nombre,35, 27,  {align:'center'});
    doc.setFont("courier", "", "bold");
    doc.text('Telefono', 35, 30, {align:'center'});
    doc.setFont("courier", "", "bold");
    doc.text(this.configuracion.sucursal.telefono,35, 33,  {align:"center"});
    doc.setFont("courier", "", "bold");
    doc.text('Correo',35, 36,  {align:'center'});
    doc.setFont("courier", "", "bold");
    doc.text(this.configuracion.sucursal.correo,35, 39,  {align:"center"});

    doc.setFontSize(6);
    doc.text('--------------------------------------------------',35, 45,  {align:'center'});
    doc.setFontSize(7);
    doc.text('CÓDIGO: ' + item.movimientos.codigo,67, 50,  {align:'right'});
    doc.text('FECHA: ' + item.created_at,67, 54,  {align:'right'});
    doc.text(
      "CLIENTE: " + item.movimientos.personas.nombre_completo,
      69,
      58,
      {align:"right"}
    );

    doc.setFontSize(6);
    doc.text('--------------------------------------------------',35, 63,  {align:'center'});

    doc.setFontSize(6);
    doc.setFont("courier", "", "bold");
    doc.text('DETALLE',35, 68,  {align:'center'});
    doc.text('CANT.', 5, 73, {align:'left'});
    doc.text('PRECIO', 14, 73, {align:'left'});
    doc.text('DESCUENTO',32, 73,  {align:'left'});
    doc.text('IMPORTE',50, 73,  {align:'left'});

    doc.setFont("courier", "", "bold");
    doc.setFontSize(6);
    let lineaY = 76;
    for (let k in item.movimientos.movimientos_articulos) {
      doc.text("ARTICULO: ",5, lineaY,  {align:"left"});
      doc.text(item.movimientos.movimientos_articulos[k].articulos.nombre,18, lineaY,  {align:'left'});
      lineaY = lineaY + 3;
      doc.text(item.movimientos.movimientos_articulos[k].cantidad,5, lineaY,  {align:'left'});
      doc.text(this.convertirMoneda(item.movimientos.movimientos_articulos[k].precio_unitario), 14, lineaY, {align:'left'});
      doc.text(this.convertirMoneda(item.movimientos.movimientos_articulos[k].descuento), 45, lineaY, {align:'right'});
      doc.text(this.convertirMoneda(item.movimientos.movimientos_articulos[k].precio_con_descuentos),64, lineaY,  {align:'right'});

      lineaY = lineaY + 2;
      doc.text("--------------------------------------------------", 35, lineaY, {align:"center"});

      lineaY = lineaY + 3;
    }

    lineaY = (lineaY - 3) + 5;

    doc.setFontSize(6);
    doc.setFont("courier", "", "bold");
    doc.text('SUBTOTAL: ' + this.convertirMoneda(item.movimientos.subtotal), 67, lineaY, {align:'right'});
    lineaY = lineaY + 4;
    doc.text('DESCUENTO: ' + this.convertirMoneda(item.movimientos.descuento), 67, lineaY, {align:'right'});
    lineaY = lineaY + 4;
    doc.text( 'TOTAL: ' + this.convertirMoneda(item.movimientos.total),67, lineaY, {align:'right'});
    lineaY = lineaY + 4;
    doc.text(item.movimientos.pagos[0].tipos_formas_pagos.nombre.toUpperCase() + ": " + this.convertirMoneda(item.movimientos.pagos[0].paga_con),67, lineaY,  {align:'right'});
    doc.setFont("courier", "", "bold");
    lineaY = lineaY + 4;
    doc.text("CAMBIO: " + this.convertirMoneda(item.movimientos.pagos[0].cambio),67, lineaY,  {align:'right'});
    doc.setFont("courier", "", "bold");
    lineaY = lineaY + 4;
    doc.text(item.movimientos.pagos[0].tipos_metodos_pagos.nombre.toUpperCase(),67, lineaY,  {align:'right'});

    doc.setFontSize(6);
    lineaY = lineaY + 5;
    doc.text('--------------------------------------------------',35, lineaY,  {align:'center'});
    doc.setFontSize(6);
    lineaY = lineaY + 4;
    if (this.configuracion.sucursal.imprimir_usuario_ticket) {
      doc.text('Atendió: ' + item.movimientos.usuarios.nombre, 35, lineaY, {align:'center'});
      lineaY = lineaY + 4;
    }
    doc.setFontSize(7);
    doc.setFont("courier", "", "bold");
    doc.text(this.configuracion.sucursal.mensaje ? this.configuracion.sucursal.mensaje : 'Gracias por su pago',35, lineaY,  {align:"center"});
    lineaY = lineaY + 2;
    doc.addImage(imgData, 'JPEG', 15, lineaY, 40, 3, 'center');

    // doc.autoPrint();
    //const string = (doc as any).output('datauristring', 'ticket.pdf');
    window.open((doc as any).output('bloburl'), '_blank');
    /*const iframe = "<iframe border='0' style='border:0px' width='100%' height='100%' src='" + string + "'></iframe>"

    const x = window.open();
    x.document.open();
    x.document.write(iframe);
    x.document.close();*/
  }

  imprimeFactura(json, logo, personas_rfcs_seleccionado = null) {

    let doc = new jsPDF('portrait', 'mm', 'letter');

    let linea = 10;

    doc.setFont("courier");
    doc.setFontSize(9);
    doc.setFont("courier", "", "bold");
    doc.text(json.Emisor.Nombre.toUpperCase(),209, linea,  {align:'right'});

    linea += 5;

    doc.setLineWidth(0.1);
    doc.setDrawColor(1, 1, 1);
    doc.setFillColor(255, 255, 255);

    // folio fiscal y emisor
    doc.roundedRect(10, linea, 30, 32, 2, 2, 'FD');
    doc.line(13, linea + 3, 37, linea + 3);

    doc.roundedRect(41, linea, 103, 32, 2, 2, 'FD');
    doc.line(44, linea + 3, 141, linea + 3);

    doc.roundedRect(145, linea, 65, 32, 2, 2, 'FD');
    doc.line(148, linea + 3, 207, linea + 3);

    doc.setFont("courier");
    doc.setFontSize(7);
    doc.setFont("courier", "", "bold");

    if(logo && logo != ''){
      if(logo.hasOwnProperty('sucursal'))
        logo = logo.sucursal;
      doc.addImage(logo, "PNG", 12, linea + 5, 26, 26, "", "FAST");
    }

    doc.text('Folio fiscal: ',44, linea + 8,  {align:'left'});
    doc.text('No. de serie del CSD: ',44, linea + 13,  {align:'left'});
    doc.text('No. de serie del certificado SAT: ', 44, linea + 18, {align:'left'});
    doc.text('Fecha y hora de emisión: ', 44, linea + 23,{align:'left'});
    doc.text('Fecha y hora de certificación: ', 44, linea + 28, {align:'left'});

    doc.text('Dirección: ',148, linea + 8,  {align:'left'});
    doc.text('R.F.C.: ',148, linea + 13,  {align:'left'});
    doc.text('Lugar de expedición: ', 148, linea + 18, {align:'left'});
    doc.text('Régimen fiscal: ',148, linea + 23,  {align:'left'});
    doc.text('Tipo de comprobante: ',148, linea + 28,  {align:'left'});

    doc.setFont("courier", "", "normal");

    doc.text(json.Complemento.TimbreFiscalDigital.UUID,70.5, linea + 8,  {align:'left'});
    doc.text(json.NoCertificado,94, linea + 13,  {align:'left'});
    doc.text(json.Complemento.TimbreFiscalDigital.NoCertificadoSAT,94, linea + 18,  {align:'left'});
    doc.text(json.Fecha,94, linea + 23, {align:'left'});
    doc.text(json.Complemento.TimbreFiscalDigital.FechaTimbrado,95.5, linea + 28,  {align:'left'});

    doc.setFont("courier", "", "bold");

    doc.setFont("courier", "", "normal");

    doc.text(this.configuracion.sucursal.direccion.split(',')[0],163, linea + 8,  {align:'left'});
    doc.text(json.Emisor.Rfc,162, linea + 13,  {align:'left'});
    doc.text(json.LugarExpedicion, 182, linea + 18, {align:'left'});
    doc.text(json.Emisor.RegimenFiscal,182, linea + 23,  {align:'left'});
    doc.text(json.TipoDeComprobante, 182, linea + 28, {align:'left'});

    linea += 33;

    // Receptor y uso
    doc.setLineWidth(0.1);
    doc.setDrawColor(1, 1, 1);
    doc.setFillColor(255, 255, 255);

    doc.roundedRect(10, linea, 134, 17, 2, 2, 'FD');
    doc.line(13, linea + 3, 141, linea + 3);
    doc.roundedRect(145, linea, 65, 17, 2, 2, 'FD');
    doc.line(148, linea + 3, 207, linea + 3);

    doc.setFont("courier");
    doc.setFontSize(7);
    doc.setFont("courier", "", "bold");

    doc.text('Receptor: ',13, linea + 6,  {align:'left'});
    doc.text('R.F.C.: ', 13, linea + 11, {align:'left'});
    doc.text('Domicilio: ', 13, linea + 16, {align:'left'});

    doc.text('Uso CFDI: ',148, linea + 8,  {align:'left'});
    doc.text('Folio y serie: ',148, linea + 13,  {align:'left'});

    doc.setFont("courier", "", "normal");

    doc.text(json.Receptor.Nombre.toUpperCase(),28, linea + 6,  {align:'left'});
    doc.text(json.Receptor.Rfc,28, linea + 11, {align:'left'});

    let direccion = '';
    if(personas_rfcs_seleccionado){
    direccion = personas_rfcs_seleccionado.calle + " #" + 
        personas_rfcs_seleccionado.numero_exterior + ", " + 
        (personas_rfcs_seleccionado.numero_interior ? " INT. " + personas_rfcs_seleccionado.numero_interior + "," : "")  + 
        personas_rfcs_seleccionado.colonia  + ", CP:" + 
        personas_rfcs_seleccionado.codigo_postal + ", " + 
        personas_rfcs_seleccionado.municipios.nombre + ", " +  
        personas_rfcs_seleccionado.estados.nombre;
    }

    var splitTitle = doc.splitTextToSize(direccion, 112);
    doc.text(splitTitle, 28, linea + 16, {maxWidth: 112, align: "justify"});

    doc.text(json.Receptor.UsoCFDI,170, linea + 8,  {align:'left'});
    doc.text(json.Folio + " " + json.Serie,170, linea + 13,  {align:'left'});

    linea += 18;

    // Detalles de alumno
    doc.setLineWidth(0.1);
    doc.setDrawColor(1, 1, 1);
    doc.setFillColor(255, 255, 255);
    doc.setFont("courier", "", "bold");

    if (json.Conceptos.Concepto.length > 0) {
      if (json.Conceptos.Concepto[0].ComplementoConcepto != undefined) {
        doc.roundedRect(10, linea, 200, 18, 2, 2, 'FD');
        doc.line(13, linea + 3, 207, linea + 3);

        linea += 7;

        doc.text('IEDU Versión',13, linea,  {align:'left'});
        doc.text('Alumno',38, linea,  {align:'left'});
        doc.text('CURP',105, linea, {align:'left'});
        doc.text('Nivel',140, linea,  {align:'left'});
        doc.text('RVOE',173, linea,  {align:'left'});

        doc.line(13, linea + 2, 207, linea + 2);

        linea += 8;
        doc.setFont("courier", "", "normal");

        doc.text(json.Conceptos.Concepto[0].ComplementoConcepto.version,13, linea,  {align:'left'});
        doc.text(json.Conceptos.Concepto[0].ComplementoConcepto.nombreAlumno,38, linea,  {align:'left'});
        doc.text(json.Conceptos.Concepto[0].ComplementoConcepto.CURP ?? '',105, linea,  {align:'left'});
        doc.text(json.Conceptos.Concepto[0].ComplementoConcepto.nivelEducativo, 140, linea, {align:'left'});
        doc.text(json.Conceptos.Concepto[0].ComplementoConcepto.autRVOE,173, linea,  {align:'left'});

        linea += 4;
      }
    }

    doc.setLineWidth(0.1);
    doc.setDrawColor(1, 1, 1);
    doc.setFillColor(255, 255, 255);
    doc.setFont("courier", "", "bold");

    // Detalles de productos
    let tam_art = (json.Conceptos.Concepto.length + 1) * 6.2;
    json.Conceptos.Concepto.forEach(concepto => {
      tam_art += ((concepto.Descripcion.length / 44) * 1.2);
    });

    tam_art += 6;
    let linea_temp = linea + 1;
    if ((linea + tam_art) > 270)
      tam_art = 200;

    doc.roundedRect(10, linea, 200, tam_art, 2, 2, 'FD');
    doc.line(13, linea + 3, 207, linea + 3);

    linea += 8;
    doc.setFontSize(6);
    doc.setFont("courier", "", "bold");

    doc.text('Prod/Serv',13, linea,  {align:'left'});
    doc.text('No.Id.',27, linea,  {align:'left'});
    doc.text('Cant.', 36, linea, {align:'left'});
    doc.text('Unidad',44, linea,  {align:'left'});
    doc.text('Descripción',65, linea,  {align:'left'});
    doc.text('Precio', 124, linea, {align:'left'});
    doc.text('Descuento',141, linea,  {align:'left'});
    doc.text('Impuesto',158, linea,  {align:'left'});
    doc.text('Importe',188, linea,  {align:'left'});

    doc.line(13, linea + 3, 207, linea + 3);

    doc.setLineWidth(0.1);
    doc.setDrawColor(1, 1, 1);
    doc.setFillColor(255, 255, 255);
    doc.setFont("courier", "", "normal");

    json.Conceptos.Concepto.forEach((concepto, numero) => {
      linea += 6;
      doc.text(concepto.ClaveProdServ,13, linea,  {align:'left'});
      doc.text(concepto.NoIdentificacion, 27, linea, {align:'left'});
      doc.text(concepto.Cantidad,36, linea,  {align:'left'});
      if (concepto.Unidad.indexOf(concepto.ClaveUnidad) == -1) {
        doc.text(concepto.ClaveUnidad,44, linea,  {align:'left'});
        doc.setFontSize(3.5);
        doc.text(concepto.Unidad,48, linea,  {align:'left'});
      } else {
        doc.setFontSize(4);
        doc.text(concepto.Unidad,44, linea,  {align:'left'});
      }
      doc.setFontSize(6);
      let descripcion = []; let cadena = ''; let index = 0;
      if (concepto.Descripcion.length <= 44) {
        descripcion.push(concepto.Descripcion);
      } else {
        for (let i = 0; i < concepto.Descripcion.length; i++) {
          cadena += concepto.Descripcion.charAt(i);
          if (index == 44) {
            descripcion.push(cadena);
            cadena = '';
            index = 0;
          }
          index++;
        }
        if (cadena != '') {
          descripcion.push(cadena);
        }
        linea = linea - 3;
        linea += Math.trunc((concepto.Descripcion.length / 44) * 3);
      }
      let indice = 0;
      descripcion.forEach(texto => {
        doc.text(texto,65, linea + indice,  {align:'left'});
        if (descripcion.length > 1) {
          indice += 3;
        }
      });

      doc.setFontSize(5);

      doc.text(this.convertirMoneda(concepto.ValorUnitario),124, linea,  {align:'left'});
      doc.text(this.convertirMoneda(concepto.Descuento), 141, linea, {align:'left'});

      doc.setFontSize(3.5);

      if(concepto.Impuestos){
        if (concepto.Impuestos.Traslados)
        if (concepto.Impuestos.Traslados.length > 0) {
          doc.text("Traslados", 158, linea - 1, {align:'left'});
          let linea_tr = 0;
          concepto.Impuestos.Traslados.forEach(tr => {
            linea_tr += 2;
            let factor = tr.Traslado.TipoFactor == "Tasa" ? (tr.Traslado.TasaOCuota * 100) + "%" : tr.Traslado.TasaOCuota;
            let impuesto = "" + tr.Traslado.Impuesto + "(" + factor + "): " + this.convertirMoneda(tr.Traslado.Importe);
            doc.text(impuesto,158, (linea - 1) + linea_tr,  {align:'left'});
          });
        }
        if (concepto.Impuestos.Retenciones)
        if (concepto.Impuestos.Retenciones.length > 0) {
          doc.text("Retenciones",173, linea - 1,  {align:'left'});
          let linea_re = 0;
          concepto.Impuestos.Retenciones.forEach(re => {
            linea_re += 2;
            let factor = re.Retencion.TipoFactor == "Tasa" ? (re.Retencion.TasaOCuota * 100) + "%" : re.Retencion.TasaOCuota;
            let impuesto = "" + re.Retencion.Impuesto + "(" + factor + "): " + this.convertirMoneda(re.Retencion.Importe);
            doc.text(impuesto,173, (linea - 1) + linea_re,  {align:'left'});
          });
        }
      }
      doc.setFontSize(5);

      doc.text(this.convertirMoneda(concepto.Importe),188, linea,  {align:'left'});

      doc.setFontSize(6);
      linea += 1;
      doc.line(13, linea + 3, 207, linea + 3);

      if (linea > 250) {
        linea = 10;
        doc.addPage();

        tam_art = ((json.Conceptos.Concepto.length - numero) + 1) * 6.2;
        json.Conceptos.Concepto.forEach((concepto, num) => {
          if (num > numero)
            tam_art += ((concepto.Descripcion.length / 44) * 1.2);
        });

        tam_art += 6;
        linea_temp = linea + 1;
        if ((linea + tam_art) > 270)
          tam_art = 200;

        doc.setLineWidth(0.1);
        doc.setDrawColor(1, 1, 1);
        doc.setFillColor(255, 255, 255);
        doc.setFont("courier", "", "bold");

        doc.roundedRect(10, linea, 200, tam_art, 2, 2, 'FD');
        doc.line(13, linea + 3, 207, linea + 3);

        linea += 8;
        doc.setFontSize(6);
        doc.setFont("courier", "", "bold");

        doc.text('Prod/Serv', 13, linea, {align:'left'});
        doc.text('No.Id.',27, linea,  {align:'left'});
        doc.text('Cant.', 36, linea, {align:'left'});
        doc.text('Unidad',44, linea,  {align:'left'});
        doc.text('Descripción',65, linea,  {align:'left'});
        doc.text('Precio',124, linea,  {align:'left'});
        doc.text('Descuento',141, linea,  {align:'left'});
        doc.text('Impuesto',158, linea,  {align:'left'});
        doc.text('Importe',188, linea,  {align:'left'});

        doc.line(13, linea + 3, 202, linea + 3);

        doc.setLineWidth(0.1);
        doc.setDrawColor(1, 1, 1);
        doc.setFillColor(255, 255, 255);
        doc.setFont("courier", "", "normal");
      }

    });

    linea = linea_temp + tam_art;
    if ((linea + 30) > 270) {
      linea = 10;
      doc.addPage();
    }

    doc.setLineWidth(0.1);
    doc.setDrawColor(1, 1, 1);
    doc.setFillColor(255, 255, 255);

    doc.setFont("courier");
    doc.setFontSize(7);
    doc.setFont("courier", "", "bold");

    // Totales

    doc.roundedRect(10, linea, 134, 29, 2, 2, 'FD');
    doc.line(13, linea + 3, 141, linea + 3);
    doc.roundedRect(145, linea, 65, 29, 2, 2, 'FD');
    doc.line(148, linea + 3, 207, linea + 3);

    doc.text('Total con letra: ',13, linea + 8,  {align:'left'});
    doc.line(13, linea + 12, 141, linea + 12);
    doc.text('Moneda: ',13, linea + 20,  {align:'left'});
    doc.text('Forma de pago: ',13, linea + 25,  {align:'left'});

    doc.text('Método de pago: ',78, linea + 20,  {align:'left'});
    doc.text('Condiciones de pago: ', 78, linea + 25, {align:'left'});

    doc.text('Subtotal: ',148, linea + 8,  {align:'left'});
    doc.text('Descuento: ', 148, linea + 12, {align:'left'});


    doc.setFont("courier", "", "normal");

    doc.text( this.convertirImporteLetra(json.Total),38, linea + 8, {align:'left'});
    doc.text(json.Moneda,35, linea + 20,  {align:'left'});
    doc.text(json.FormaPago, 35, linea + 25, {align:'left'});

    doc.text(json.MetodoPago,115, linea + 20,  {align:'left'});
    doc.text(json.CondicionesDePago,115, linea + 25,  {align:'left'});

    doc.text(this.convertirMoneda(json.SubTotal),165, linea + 8,  {align:'left'});
    doc.text(this.convertirMoneda(json.Descuento),165, linea + 12,  {align:'left'});

    doc.setFontSize(5);
    let tem_linea = linea + 16;
    let linea_ret = 0;
    let linea_tra = 0;
    if(json.Impuestos){
      
      if (json.Impuestos.Traslados)
      if (json.Impuestos.Traslados.length > 0) {
        doc.text("Traslados",148, tem_linea - 1,  {align:'left'});
        let linea_tr = 0;
        json.Impuestos.Traslados.forEach(tr => {
          linea_tr += 2;
          let factor = tr.Traslado.TipoFactor == "Tasa" ? (tr.Traslado.TasaOCuota * 100) + "%" : tr.Traslado.TasaOCuota;
          let impuesto = "" + tr.Traslado.Impuesto + "(" + factor + "): " + this.convertirMoneda(tr.Traslado.Importe);
          doc.text(impuesto, 148, (tem_linea - 1) + linea_tr, {align:'left'});
          linea_tra++;
        });
      }
      if (json.Impuestos.Retenciones)
      if (json.Impuestos.Retenciones.length > 0) {
        doc.text("Retenciones",175, tem_linea - 1,  {align:'left'});
        let linea_re = 0;
        json.Impuestos.Retenciones.forEach(re => {
          linea_re += 2;
          let factor = re.Retencion.TipoFactor == "Tasa" ? (re.Retencion.TasaOCuota * 100) + "%" : re.Retencion.TasaOCuota;
          let impuesto = "" + re.Retencion.Impuesto + "(" + factor + "): " + this.convertirMoneda(re.Retencion.Importe);
          doc.text(impuesto,175, (tem_linea - 1) + linea_re,  {align:'left'});
          linea_ret ++;
        });
      }
    }
    let linea_t = linea + ((linea_ret > linea_tra ? linea_ret : linea_tra) * 2) + 4;
    doc.setFontSize(10);

    doc.setFont("courier", "", "bold");
    doc.text('Total: ',148, linea_t + 17,  {align:'left'});
    doc.setFont("courier", "", "normal");
    doc.text(this.convertirMoneda(json.Total),165, linea_t + 17,  {align:'left'});

    doc.setFontSize(6);

    linea += 30;

    if ((linea + 35) > 270) {
      linea = 10;
      doc.addPage();
    }

    doc.setLineWidth(0.1);
    doc.setDrawColor(1, 1, 1);
    doc.setFillColor(255, 255, 255);
    doc.setFont("courier", "", "bold");

    // QR y sellos
    doc.setFontSize(7);

    doc.roundedRect(10, linea, 30, 35, 2, 2, 'FD');
    doc.line(13, linea + 3, 37, linea + 3);
    doc.roundedRect(41, linea, 169, 35, 2, 2, 'FD');
    doc.line(44, linea + 3, 207, linea + 3);

    doc.text('Sello digital del CFDI: ', 44, linea + 8, {align:'left'});
    doc.text('Sello digital del SAT: ',44, linea + 16,  {align:'left'});
    doc.text('Cadena original del complemento de certificación del SAT: ',44, linea + 24,  {align:'left'});

    doc.setFont("courier", "", "normal");

    if (json.Complemento.TimbreFiscalDigital.qr && json.Complemento.TimbreFiscalDigital.qr != '')
      doc.addImage(json.Complemento.TimbreFiscalDigital.qr, "PNG", 10.5, linea + 5, 29, 29, "", "FAST");

    let Sello = json.Complemento.TimbreFiscalDigital.SelloCFD;
    let SelloCFD = [];
    SelloCFD[0] = Sello.substr(0, 134);
    SelloCFD[1] = Sello.substr(134, 170);
    SelloCFD[2] = Sello.substr(304, Sello.length);

    let SAT = json.Complemento.TimbreFiscalDigital.SelloSAT;
    let SelloSAT = [];
    SelloSAT[0] = SAT.substr(0, 134);
    SelloSAT[1] = SAT.substr(134, 170);
    SelloSAT[2] = SAT.substr(304, Sello.length);

    let Original = json.Complemento.TimbreFiscalDigital.CadenaOriginal;
    let CadenaOriginal = [];
    CadenaOriginal[0] = Original.substr(0, 81);
    CadenaOriginal[1] = Original.substr(81, 170);
    CadenaOriginal[2] = Original.substr(251, 170);
    CadenaOriginal[3] = Original.substr(421, Original.length);

    doc.setFontSize(4.5);

    doc.text(SelloCFD[0],78, linea + 8,  {align:'left'});
    doc.text(SelloCFD[1],44, linea + 10,  {align:'left'});
    doc.text(SelloCFD[2],44, linea + 12,  {align:'left'});

    doc.text(SelloSAT[0],78, linea + 16,  {align:'left'});
    doc.text(SelloSAT[1], 44, linea + 18, {align:'left'});
    doc.text(SelloSAT[2],44, linea + 20,  {align:'left'});

    doc.text(CadenaOriginal[0],129, linea + 24,  {align:'left'});
    doc.text(CadenaOriginal[1],44, linea + 26,  {align:'left'});
    doc.text(CadenaOriginal[2],44, linea + 28,  {align:'left'});
    doc.text(CadenaOriginal[3],44, linea + 30,  {align:'left'});

    doc.setFont("courier", "", "normal");
    doc.text('Este documento es una representación impresa de un CFDI ' + json.Version,105, 273,  {align:'center'});

    // doc.autoPrint();
    //const string = (doc as any).output('datauristring', 'f.pdf');
    window.open((doc as any).output('bloburl'), '_blank');
    /*const iframe = "<iframe border='0' style='border:0px' width='100%' height='100%' src='" + string + "'></iframe>"

    const x = window.open();
    x.document.open();
    x.document.write(iframe);
    x.document.close();*/
  }

  convertirMoneda(importe) {
    return (new CurrencyPipe('en')).transform(importe, this.configuracion.sucursal.moneda, true);
  }
  convertirImporteLetra(importe){
    return (new NumeroLetraPipe()).transform(importe, this.configuracion.sucursal.moneda);
  }

  excel(titulo) {
    let colspan = document.getElementsByTagName("table")[0].children[0]
      .children[0].childElementCount;
    let excelData =
      "<table><tr><th colspan='" +
      colspan +
      "'><h1>" +
      titulo +
      " <h1></th></tr></table>";

    excelData += document.getElementById("exportar_datos").innerHTML;
    let blob = new Blob([excelData], {
      type: "text/comma-separated-values;charset=utf-8"
    });
    saveAs(blob, titulo + ".xls");
  }

  logo_sucursal;
  logo_empresa;
  logos64;

  asignarLogos(logos) {
    if (logos) {
      this.logo_sucursal = logos.sucursal;
      this.logo_empresa = logos.empresa;
    }
  }

  obtenerCatalogos(url, model, id = '') {
    this.parametros.pagina = 0;
    this.parametros.limite = 0;
    
    delete this.parametros.columna;
    delete this.parametros.valor;
    delete this.parametros.buscar;
    this.crudService.lista(this.parametros, url).subscribe(
      resultado => {
        this[model] = resultado.data;
        if (id != '') {
          if(document.getElementById(id))
          document.getElementById(id).click();
        }
      },
      error => {
      }
    );
  }
}
